import { TranslatedString } from "./translated-string"

export interface AssociatedMedias {
    medias?: string[],
    first?: string | null,
    second?: string | null, 
    third?: string | null
}

export interface AssociatedMediasResource {
    first?: string | null // ref to media
    second?: string | null // ref to media
    third?: string | null // ref to media
    medias?: string[] | null // refs to media
    illustratedNote?: boolean | null
    associatedAlbums?: AssociatedAlbumResource[] | null
}

export interface AssociatedMediasoid {
    medias?: any[] | null
    first?: any
    second?: any
    third?: any
}

export interface AssociatedAlbumResource {
    album?: string | null // ref to album
    commentary?: TranslatedString | null
}

export function removeRefsInAssociatedMedias(associatedMedias: AssociatedMedias, refs: string[]): AssociatedMedias {
    let res = {...associatedMedias}
    const principalMediaKeys = ['first', 'second', 'third']

    if(res.medias) {
        res.medias = res.medias.filter(mediaId => !refs.includes(mediaId))
    }

    for(const key of principalMediaKeys) {
        if(res[key] && refs.includes(res[key]) ) {
            res[key] = undefined
        }
    }

    return res
}